import React from 'react'
import ToolCard from './components/ToolCard'

const Tools = ({ id }) => {
    const toolsCardsData = [
        { title: `Update Project's Remote Config`, link: `/customer/${id}/projects` },
        {
            title: `Feature Toggle`,
            link: `/customer/${id}/features`,
            description: `Use this tool to enable/disable premium features for this account.`,
        },
        { title: `Create Activity CSV Report`, link: `/customer/${id}/reports` },
        { title: `Monthly Activity Report`, link: `/customer/${id}/checkinsReport` },
        { title: `Import Zones from CSV`, link: `/customer/${id}/importZones`},
        { title: `Update Project's Tempo Configuration`, link: `/customer/${id}/tempoConfiguration`},
        { title: `Create Visualisation`, link: `/customer/${id}/visualisations`},
        { title: `Generate Wave Demo App URL`, link: `/customer/${id}/generateWaveAppUrl`},
        { title: 'Demo Oracle Simphony Integration', link: `/customer/${id}/simulators`},
        { title: 'Superuser Settings for Now Ready Screens', link: `/customer/${id}/nowReady`},
        { title: 'Generate Now Ready Demo URL', link: `/customer/${id}/nowReadyDemo`},
        { title: `Update Hello's Configuration`, link: `/customer/${id}/helloConfiguration`}
    ]

    return (
        <div className="tools-wrapper">
            {toolsCardsData.map((tool) => (
                <ToolCard title={tool.title} link={tool.link} description={tool.description} key={tool.title}/>
            ))}
        </div>
    )
}

export default Tools
